import styled from "styled-components";
import React, { useState } from "react";
import uploadCloud from "../../images/uploadCloud.svg"

const UploadField = styled.form<{ width?: string }>`
  height: 88px;
  width: ${(props) => props.width ?? "100%"};
  text-align: center;
  position: relative;
  margin-bottom: 12px;
  
  input {
    display: none;
  }

  label {
    height: 100%;
    display: flex;
    gap: 0;
    align-items: center;
    justify-content: center;
    border: 1px dashed #2196F3;
    border-radius: 4px;
    background-color: #f8fafc;
  }
  
  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
    color: #717171;
  }

  .upload-button {
    cursor: pointer;
    padding: 0;
    border: none;
    background-color: transparent;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
    color: #2196F3;
  }

  .upload-button:hover {
    color: #56ADF3;
  }

  #drag-file-element {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
  }
`;

type FileDragDropInputFieldProps = {
  handleFile: (files: FileList) => void;
  accept: string;
  multiple?: boolean;
  textError?: string;
  width?: string;
};

let prevId = 0;

export const FileDragDropInputField = ({
    handleFile, 
    accept, 
    multiple = true, 
    textError = "Неверный формат файла"
  } : FileDragDropInputFieldProps) => {

  const [dragActive, setDragActive] = React.useState(false);
  const [error, setError] = useState<string | undefined>();

  prevId++;
  const id = "input-file-upload" + prevId;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const acceptFormats = String(accept).replace(',', '').split(' ');
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      if (acceptFormats.indexOf(e.dataTransfer.files[0].type) !== -1) {
        handleFile(e.dataTransfer.files);
        setError('');
      } else {
        setError(textError)
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };

  const onButtonClick = () => {
    inputRef.current?.click();
  };

  return(
    <UploadField onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}>
      <input ref={inputRef} type="file" id={id} multiple={multiple} onChange={handleChange} accept={accept}/>
      <label id="label-file-upload" htmlFor={id} className={dragActive ? "drag-active" : "" }>
        <div>
          <img src={uploadCloud}/>
          <div className="d-flex justify-content-center gap-1">
            <p>Перетащите сюда свои файлы или</p>
            <button className="upload-button" onClick={onButtonClick}>Загрузить</button>
          </div>
        </div>
      </label>
      { dragActive &&
        <div id="drag-file-element"
             onDragEnter={handleDrag}
             onDragLeave={handleDrag}
             onDragOver={handleDrag}
             onDrop={handleDrop}>
        </div>
      }
    </UploadField>
  )
}